import React from "react";

export default function Nav() {
  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      className="nav-blur fixed top-0 left-0 right-0 z-50"
      data-testid="main-nav"
    >
      <div className="container-nk flex items-center justify-between h-[68px]">
        <a
          href="#top"
          onClick={scrollTo("top")}
          className="flex items-center gap-3"
          data-testid="nav-logo"
        >
          <img
            src="/naami-wordmark.png"
            alt="Naami Kitchens United"
            className="h-9 md:h-10 w-auto"
            style={{ filter: "invert(1) brightness(1.05)" }}
          />
        </a>

        <ul className="hidden md:flex items-center gap-9 font-sans text-[14px]">
          <li>
            <a
              href="#brands"
              onClick={scrollTo("brands")}
              className="text-[var(--text)] hover:text-[var(--gold)] transition-colors"
              data-testid="nav-link-brands"
            >
              Our Brands
            </a>
          </li>
          <li>
            <a
              href="#about"
              onClick={scrollTo("about")}
              className="text-[var(--text)] hover:text-[var(--gold)] transition-colors"
              data-testid="nav-link-about"
            >
              About
            </a>
          </li>
          <li>
            <a
              href="#how"
              onClick={scrollTo("how")}
              className="text-[var(--text)] hover:text-[var(--gold)] transition-colors"
              data-testid="nav-link-how"
            >
              How It Works
            </a>
          </li>
          <li>
            <a
              href="#partner"
              onClick={scrollTo("partner")}
              className="text-[var(--text)] hover:text-[var(--gold)] transition-colors"
              data-testid="nav-link-partner"
            >
              Partner With Us
            </a>
          </li>
          <li>
            <a
              href="#footer"
              onClick={scrollTo("footer")}
              className="text-[var(--text)] hover:text-[var(--gold)] transition-colors"
              data-testid="nav-link-contact"
            >
              Contact
            </a>
          </li>
        </ul>

        <a
          href="#brands"
          onClick={scrollTo("brands")}
          className="btn-primary"
          data-testid="nav-order-now-btn"
        >
          Order Now
        </a>
      </div>
    </nav>
  );
}
